
import createIcon from "./createIcon";

export const UnCheckedIcon = createIcon('UnChecked', (props) => {
  return (
    <svg {...props}>
      <rect x="1.9999796748161316" y="2.0000101923942566" width="12.000000596046448" height="12.000000596046448" rx="1.3333333134651184" fillOpacity="0" strokeOpacity="1" stroke={props.color} fill="none" strokeWidth="1.3333333730697632" />
    </svg>
  )
});
